import React from "react";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import api from "../Components/Services/Api";
import { baseURL } from "./api";

// ------------------------------------------------------------
//  PDF Utility — Delivery Note with Total Quantity + Signatures
// ------------------------------------------------------------
export const generateDeliveryNotePDF = async (order) => {
  const { orderNumber, cart = [], date } = order;
  const cartVendorId = cart?.[0]?.vendorId;

  /* ------------------- Vendor Details -------------------- */
  const { data } = await api.get(`/getVendor/${cartVendorId}`);
  const vendor = data || {};

  /* -------------------- PDF Setup ------------------------ */
  const doc = new jsPDF();
  const invoiceDate = moment(date).format("DD-MM-YYYY");

  // Company Header
  doc.setFontSize(16).setFont("helvetica", "bold");
  doc.text("DZYRIS FROZEN FOODS PVT. LTD.", 14, 15);
  doc.setFontSize(10).setFont("helvetica", "normal");
  doc.text("SHOP NO.8, ARIHANT INDUSTRIAL ESTATE,", 14, 22);
  doc.text("KAMAN BHIWANDI ROAD, MORI GAON", 14, 27);
  doc.text("GSTIN: 27AAJCD8219Q1ZW | State Code: 27", 14, 32);
  doc.text("CIN: U15549MH2023PTC397586", 14, 37);
  doc.text("Contact: 9930973001 | Email: accounts@dzyris.in", 14, 42);
  doc.line(14, 45, 200, 45);

  // Delivery Note Info
  doc.setFont("helvetica", "bold").text("Delivery Note No.:", 14, 52);
  doc.setFont("helvetica", "normal").text(orderNumber || "N/A", 50, 52);
  doc.setFont("helvetica", "bold").text("Dated:", 120, 52);
  doc.setFont("helvetica", "normal").text(invoiceDate, 132, 52);

  // Vendor Info
  doc.setFont("helvetica", "bold").text("Delivered To:", 14, 60);
  doc.setFont("helvetica", "normal").text(vendor.vendorName || "N/A", 14, 65);
  doc.text(vendor.vendorAddress || "N/A", 14, 70);
  doc.text(`State: ${vendor.state || "N/A"}`, 14, 75);

  /* -------------------- Items Table ---------------------- */
  const tableColumn = ["S.No", "Description", "Qty"];
  let totalQty = 0;

  const tableRows = cart.map((item, index) => {
    const qty = Number(item.quantity) || 0;
    totalQty += qty;

    return [
      index + 1,
      item.name || "",
      qty.toFixed(2),
    ];
  });

  doc.autoTable({
    startY: 85,
    head: [tableColumn],
    body: tableRows,
    styles: { fontSize: 10, cellPadding: 3 },
    headStyles: { fillColor: [41, 128, 185], textColor: 255, halign: "center" },
    columnStyles: {
      0: { halign: "center" },
      1: {},
      2: { halign: "center" },
      3: { halign: "center" },
    },
  });

  const finalY = doc.lastAutoTable.finalY + 10;

  // Total Quantity
  doc.setFont("helvetica", "bold").setFontSize(10);
  doc.text(`Total Quantity: ${totalQty.toFixed(2)} Kg`, 14, finalY);

  /* -------------------- Signature Block ---------------------- */
  let currentY = finalY + 20;
  doc.setFont("helvetica", "normal").setFontSize(10);

  doc.text("Name :", 14, currentY);
  doc.line(35, currentY + 1, 150, currentY + 1);
  currentY += 10;

  doc.text("Authorised Signature :", 14, currentY);
  doc.line(70, currentY + 1, 150, currentY + 1);
  currentY += 10;

  doc.text("Date :", 14, currentY);
  doc.line(30, currentY + 1, 80, currentY + 1);
  currentY += 10;

  doc.text("Time :", 14, currentY);
  doc.line(30, currentY + 1, 80, currentY + 1);

  /* -------------------- Save PDF ------------------------- */
  doc.save(`${orderNumber}_DeliveryNote.pdf`);
};

// ------------------------------------------------------------
// Helper to fetch all orders & generate delivery notes
// ------------------------------------------------------------
export const fetchAndGenerateDeliveryNotes = async () => {
  try {
    const { data: orders } = await axios.get("/getAllOrders");

    if (!orders || orders.length === 0) {
      alert("No orders found.");
      return;
    }

    for (const order of orders) {
      await generateDeliveryNotePDF(order);
    }
  } catch (error) {
    console.error("Error generating delivery notes:", error);
    alert("Failed to generate delivery notes.");
  }
};

// ------------------------------------------------------------
//  Simple React button to trigger bulk download
// ------------------------------------------------------------
const DeliveryNote = () => (
  <div>
    <button onClick={fetchAndGenerateDeliveryNotes}>
      Download Delivery Notes
    </button>
  </div>
);

export default DeliveryNote;
